import { Link } from "react-router-dom";

/**
 * Breadcrumb trail for the Academy world:
 *   Academy → Living Library → Category → Entry
 * Pass items as [{ label, to }] — the last item renders as the
 * current location (gold, no link).
 */
export const LibraryBreadcrumb = ({ items, testid = "library-breadcrumb" }) => (
  <nav
    data-testid={testid}
    aria-label="Breadcrumb"
    className="flex items-center flex-wrap gap-x-3 gap-y-2 text-[11px] tracking-[0.34em] uppercase"
  >
    {items.map((it, i) => {
      const isLast = i === items.length - 1;
      return (
        <span key={`${it.label}-${i}`} className="flex items-center gap-2.5">
          {isLast || !it.to ? (
            <span className={isLast ? "text-gold" : "text-bone/50"}>{it.label}</span>
          ) : (
            <Link to={it.to} className="text-bone/50 hover:text-gold transition-colors">
              {it.label}
            </Link>
          )}
          {!isLast && <span className="text-bone/25" aria-hidden>/</span>}
        </span>
      );
    })}
  </nav>
);

export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.href ? { item: it.href } : {}),
    })),
  };
}
